// extracted by mini-css-extract-plugin
module.exports = {"container":"cards_container__2nAh3"};